import styles from "./VerticalSpacer.module.scss";
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var paddingTypes = ['default', 'topOnly', 'bottomOnly', 'none'];
export var VerticalSpacer = function VerticalSpacer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 'default' : _ref$padding;
  var defaultClass = className ? className : styles.default;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(defaultClass, {
      [styles["".concat(padding)]]: padding !== 'default'
    }),
    children: children
  });
};